import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Row, Col, } from "reactstrap";
import { toast } from "react-toastify";
import usePermissions from "../../Hooks/usePermissions";

const initialState = {
  module: "",
  name: "",
  code: "",
  description: "",
  isActive: true,
};
const modules = [ "Leads","Teams", "Users", "Projects", "Settings", "Reports"];

const PermissionModal = ({ isOpen, toggle, permission, onSuccess, }) => {
  const { createPermission, updatePermission, } = usePermissions();

  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(initialState);

  useEffect(() => {
    if (!isOpen) return;

    if (permission) {
      setForm({
        module: permission.module || "",
        name: permission.name || "",
        code: permission.code || "",
        description: permission.description || "",
        isActive: permission.isActive,
      });
    } else {
      setForm(initialState);
    }
  }, [permission, isOpen]);

  const handleChange = ({ target }) => {
    const { name, value } = target;

    setForm((prev) => ({
      ...prev,
      [name]:
        name === "isActive"
          ? value === "true"
          : value,
    }));
  };

  const handleSubmit = async () => {
    if (!form.module.trim())
      return toast.error("Module is required");

    if (!form.name.trim())
      return toast.error("Permission name is required");

    if (!form.code.trim())
      return toast.error("Permission code is required");

    try {
      setLoading(true);

      const payload = {
        module: form.module.trim(),
        name: form.name.trim(),
        code: form.code.trim(),
        description: form.description.trim(),
        isActive: form.isActive,
      };

      const res = permission?._id
        ? await updatePermission(permission._id, payload)
        : await createPermission(payload);

      if (!res?.success) {
        return toast.error(res?.message || "Operation failed");
      }

      toast.success( permission ? "Permission updated successfully" : "Permission created successfully" );

      onSuccess?.();
      toggle();
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg" >
      <ModalHeader toggle={toggle}>
        {permission ? "Edit Permission" : "Create Permission"}
      </ModalHeader>

      <ModalBody>
        <Row>

          <Col md={6}>
            <FormGroup>
                <Label>Module</Label>

                <Input
                type="select"
                name="module"
                value={form.module}
                onChange={handleChange}
                >
                <option value="">
                    Select Module
                </option>

                {modules.map((module) => (
                    <option key={module} value={module}>
                    {module}
                    </option>
                ))}
                </Input>
            </FormGroup>
            </Col>

          <Col md={6}>
            <FormGroup>
              <Label>Permission Name</Label>

              <Input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="View Leads"
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label>Permission Code</Label>

              <Input
                name="code"
                value={form.code}
                onChange={handleChange}
                placeholder="leads.view"
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label>Status</Label>

              <Input
                type="select"
                name="isActive"
                value={String(form.isActive)}
                onChange={handleChange}
              >
                <option value="true"> Active </option>
                <option value="false"> Inactive </option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={12}>
            <FormGroup>
              <Label>Description</Label>

              <Input
                type="textarea"
                rows="4"
                name="description"
                value={form.description}
                onChange={handleChange}
                placeholder="Permission description..."
              />
            </FormGroup>
          </Col>

        </Row>
      </ModalBody>

      <ModalFooter>

        <Button color="light" onClick={toggle} disabled={loading} >
          Cancel
        </Button>

        <Button color="primary" onClick={handleSubmit} disabled={loading} >
          {loading ? "Saving..." : permission ? "Update Permission" : "Create Permission"}
        </Button>

      </ModalFooter>
    </Modal>
  );
};

export default PermissionModal;